<template>
  <form @submit.prevent="submitForm">
    <div class="row q-mb-md">
      <q-input
        v-model="formData.citizenId"
        :rules="[ val => isThaiNationalID(val) || 'เลขบัตรประชาชนไม่ถูกต้อง']"
        type="number"
        ref="citizenId"
        lazy-rules
        outlined
        class="col"
        label="เลขที่บัตรประชาชน" />
    </div>
    <div class="row q-mb-md">
      <q-input
        v-model="formData.mobile"
        :rules="[ val => isMobileNUmber(val) || 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก']"
        ref="mobile"
        lazy-rules
        type="number"
        outlined
        class="col"
        label="หมายเลขโทรศัพท์" />
    </div>
    <div class="row">
      <q-btn
        class="full-width"
        color="primary"
        label="ลงทะเบียน"
        type="submit">
          <template v-slot:loading>
            <q-spinner-facebook />
          </template>
      </q-btn>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      formData: {
        citizenId: '',
        mobile: ''
      }
    }
  },
  methods: {
    ...mapActions('auth', ['registerUser', 'setProfile']),
    isMobileNUmber (mobile) {
      var re = /^[0][8,9,6][0-9]\d{7}$/g
      return re.test(String(mobile))
    },
    isThaiNationalID (id) {
      if (id == null || id.length !== 13 || !/^[0-9]\d+$/.test(id)) {
        return false
      }
      let i; let sum = 0
      for ((i = 0), (sum = 0); i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i)
      }
      const check = (11 - sum % 11) % 10
      if (check === parseInt(id.charAt(12))) {
        return true
      }
      return false
    },
    submitForm () {
      this.$refs.citizenId.validate()
      this.$refs.mobile.validate()
      if (!this.$refs.citizenId.hasError && !this.$refs.mobile.hasError) {
        this.registerUser(this.formData)
        // this.$router.push('/dashboard', () => {})
      }
    },
    registerUser () {
      axios.post(`${process.env.VUE_APP_API}api/line`, { ...this.formData, ...this.line })
        .then((res) => {
          if (res.data != null) {
            this.$router.push('/otp', () => {})
          }
          this.$q.notify({
            message: 'There is no response.',
            color: 'grey',
            textColor: 'white'
          })
        })
        .catch(e => {
          // console.log(e.toJSON())
          if (e.response.status === 401) {
            console.log(e.response.status)
            this.$router.push('/register', () => {})
          }
        })
    }
  },
  computed: {
    ...mapState('auth', ['line'])
  }
}
</script>

<style lang="scss" scoped>

</style>
